// @flow

import * as React from 'react';
import { Query } from 'react-apollo';
import recommendedConnections from './RecommendedExternalConnections.gql';

type Props = {
  /** suggested member connection type */
  connectionType: string,
  /** offset index */
  offset: number,
  /** number of suggestions to fetch */
  limit: number,
  children: (() => Promise<*>, any, boolean, any, boolean, any, any) => React.Node,
};

const maxRetries = 3;
const retryTimeout = 1000;
let currentRetries = 0;

class SuggestedFacebookMembersDataProvider extends React.Component<Props> {
  static defaultProps = {
    connectionType: 'FACEBOOK',
    offset: 0,
    limit: 20,
  };

  render() {
    return (
      <Query
        errorPolicy="all"
        notifyOnNetworkStatusChange
        /* $FlowFixGraphql (WP-1357) */
        query={recommendedConnections}
        /* $FlowFixGraphql (WP-1357) */
        variables={{
          /* $FlowFixGraphql (WP-1357) */
          connectionType: this.props.connectionType,
          offset: this.props.offset,
          limit: this.props.limit,
        }}
      >
        {({ data, error, loading, refetch, fetchMore }) => {
          const updateRecommendedConnections = () =>
            fetchMore({
              variables: {
                // $FlowFixGraphql
                offset: data.recommendedExternalConnectionsToFollow.connections.length,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                /* $FlowFixGraphql (WP-1357) */
                if (!fetchMoreResult || !prev.recommendedExternalConnectionsToFollow.hasMore)
                  return prev;

                return Object.assign({}, prev, {
                  /* $FlowFixGraphql (WP-1357) */
                  recommendedExternalConnectionsToFollow: {
                    connections: [
                      /* $FlowFixGraphql (WP-1357) */
                      ...prev.recommendedExternalConnectionsToFollow.connections,
                      /* $FlowFixGraphql (WP-1357) */
                      ...fetchMoreResult.recommendedExternalConnectionsToFollow.connections,
                    ],
                    /* $FlowFixGraphql (WP-1357) */
                    hasMore: fetchMoreResult.recommendedExternalConnectionsToFollow.hasMore,
                    /* $FlowFixGraphql (WP-1357) */
                    __typename: prev.recommendedExternalConnectionsToFollow.__typename,
                  },
                });
              },
            });

          const retry = () => {
            // If the query data shows 'PENDING', the friend data is not yet available. Reattempt the query before showing an error screen.
            if (currentRetries < maxRetries) {
              currentRetries++;
              // Something buggy is going on with Apollo, and the query isn't being rerendered after the refetch call is completed.
              // This is a super-hack to force it to rerender when the query completes. It probably shouldn't stay.
              // Also, the only reason this component is written as a class is to be able to call forceUpdate.
              setTimeout(() => {
                refetch().then(() => this.forceUpdate());
              }, retryTimeout);
            }
            currentRetries = 0;
          };

          return this.props.children(
            updateRecommendedConnections,
            data && data.recommendedExternalConnectionsToFollow
              ? /* $FlowFixGraphql (WP-1357) */
                data.recommendedExternalConnectionsToFollow.connections
              : [],
            /* $FlowFixGraphql (WP-1357) */
            data && data.recommendedExternalConnectionsToFollow
              ? data.recommendedExternalConnectionsToFollow.hasMore
              : false,
            data &&
              data.recommendedExternalConnectionsToFollow &&
              /* $FlowFixGraphql (WP-1357) */
              data.recommendedExternalConnectionsToFollow.status,
            loading,
            error,
            retry,
          );
        }}
      </Query>
    );
  }
}

export default SuggestedFacebookMembersDataProvider;
